var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveButtonActionShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.43,18h-10.43s.01,0,.02,0c.12,0,.24-.02.35-.07.12-.05.24-.13.33-.22l6.58-6.58c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0l-4.87,4.87V1C13,.45,12.55,0,12,0s-1,.45-1,1v13.59l-4.87-4.87c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l6.58,6.58s.03.02.04.03c.08.08.18.14.28.19.12.05.25.08.38.08H1.57c-.55,0-1,.45-1,1s.45,1,1,1h20.86c.55,0,1-.45,1-1s-.45-1-1-1Z",
    fill: "#030303",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveButtonActionShare);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-button-action-share.3684082a2c120d0251a33396ce9dbad8.svg";
export { ForwardRef as ReactComponent };